import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod/v4'

export function sdkEnv() {
  return createEnv({
    server: {
      XENDIT_SERVER_KEY: z.string().min(1),
      R2_ACCOUNT_ID: z.string().min(1),
      R2_ACCESS_KEY_ID: z.string().min(1),
      R2_SECRET_ACCESS_KEY: z.string().min(1),
      CODA_API_KEY: z.string().min(1),
      TRIGGER_SECRET_KEY: z.string().min(1),
      VAPID_PRIVATE_KEY: z.string().min(1),
      LEGACY_SALT_HASH: z.string().min(1),
      ELEVENLABS_API_KEY: z.string().min(1),
      SENTRY_AUTH_TOKEN: z.string().min(1),
      NODE_ENV: z.enum(['development', 'production']).optional(),
      VERCEL_GIT_COMMIT_SHA: z.string().min(1).optional(),
      TWILIO_ACCCOUNT_SID: z.string().min(1),
      TWILIO_AUTH_TOKEN: z.string().min(1),
      TWILIO_SERVICE_SID: z.string().min(1),
      SENDGRID_API_KEY: z.string().min(1),
    },
    clientPrefix: 'NEXT_PUBLIC',
    client: {
      NEXT_PUBLIC_PROD_ENV: z.enum(['development', 'production', 'staging']).optional(),
      NEXT_PUBLIC_XENDIT_CLIENT_KEY: z.string().min(1),
      NEXT_PUBLIC_VAPID_PUBLIC_KEY: z.string().min(1),
      NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA: z.string().min(1).optional(),
      NEXT_PUBLIC_R2_PUBLIC_URL: z.string().min(1),
      NEXT_PUBLIC_CONTENT_URL: z
        .string()
        .min(1)
        .refine((s) => new URL(s)),
    },
    runtimeEnv: process.env,
    skipValidation:
      !!process.env.CI ||
      process.env.npm_lifecycle_event === 'lint' ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      typeof (globalThis as any).window !== 'undefined', // Skip in browser
  })
}
